import React from "react"
import { GlowingEffect } from "@/components/ui/glowing-effect"
import { Sparkles, Info, ShieldCheck } from "lucide-react"
import { cn } from "@/lib/utils"

type CardProps = {
  icon: React.ReactNode
  title: string
  description: string
  className?: string
}

function GlowingCard({ icon, title, description, className }: CardProps) {
  return (
    <li className={cn("list-none", className)}>
      <div className="relative h-full rounded-[1.25rem] border-[0.75px] border-[#121212] p-2 md:rounded-[1.5rem] md:p-3">
        <GlowingEffect spread={40} glow disabled={false} proximity={64} inactiveZone={0.01} borderWidth={3} />
        <div className="relative flex h-full flex-col justify-between gap-6 overflow-hidden rounded-xl border-[0.75px] border-[#121212] bg-background p-6 shadow-sm dark:shadow-[0px_0px_27px_0px_rgba(45,45,45,0.3)] md:p-6">
          <div className="relative flex flex-1 flex-col justify-between gap-3">
            <div className="w-fit rounded-lg border-[0.75px] border-[#121212] bg-muted p-2">{icon}</div>
            <div className="space-y-3">
              <h3 className="pt-0.5 text-xl font-semibold tracking-[-0.04em] text-balance md:text-2xl">{title}</h3>
              <p className="text-sm text-muted-foreground md:text-base">{description}</p>
            </div>
          </div>
        </div>
      </div>
    </li>
  )
}

export default function MonitoringGlowingSection() {
  return (
    <section id="monitoramento" className="py-16">
      <div className="mx-auto max-w-[1550px] px-6">
        <ul className="grid grid-cols-1 gap-4 md:grid-cols-3">
          <GlowingCard
            icon={<Sparkles className="h-4 w-4" />}
            title="Monitoramento em Tempo Real"
            description={"O Cripto Alert acompanha o mercado 24/7 para identificar movimentos e condi\u00e7\u00f5es t\u00e9cnicas relevantes no momento em que surgem."}
          />
          <GlowingCard
            icon={<Info className="h-4 w-4" />}
            title="Alertas com contexto"
            description={"Cada alerta inclui contexto t\u00e9cnico (indicadores, conflu\u00eancias e crit\u00e9rios de invalida\u00e7\u00e3o) para apoiar sua an\u00e1lise com clareza."}
          />
          <GlowingCard
            icon={<ShieldCheck className="h-4 w-4" />}
            title="Metodologia Transparente"
            description={"Cada alerta \u00e9 audit\u00e1vel, com m\u00e9tricas claras e trilhas de valida\u00e7\u00e3o \u2014 transpar\u00eancia em primeiro lugar."}
          />
        </ul>
      </div>
    </section>
  )
}
